struct Params_std140_0
{
    @align(16) worldSize_0 : vec2<f32>,
    @align(8) viewSize_0 : vec2<f32>,
    @align(16) gridSize_0 : vec2<f32>,
    @align(8) dotSize_0 : vec2<f32>,
    @align(16) fieldUvScale_0 : vec2<f32>,
    @align(8) pointer_0 : vec2<f32>,
    @align(16) pointerRadius_0 : f32,
    @align(4) pointerForce_0 : f32,
    @align(8) particleCount_0 : f32,
    @align(4) binCount_0 : f32,
    @align(16) binSize_0 : f32,
    @align(4) returnForce_0 : f32,
    @align(8) returnDamping_0 : f32,
    @align(4) dt_0 : f32,
    @align(16) mu_k_0 : f32,
    @align(4) sigma_k_0 : f32,
    @align(8) w_k_0 : f32,
    @align(4) mu_g_0 : f32,
    @align(16) sigma_g_0 : f32,
    @align(4) c_rep_0 : f32,
    @align(8) r_rep_0 : f32,
    @align(4) resetAttempts_0 : f32,
    @align(16) initialFieldScattering_0 : f32,
};

@binding(0) @group(0) var<uniform> data_params_0 : Params_std140_0;
struct Particle_std430_0
{
    @align(8) position_0 : vec2<f32>,
    @align(8) velocity_0 : vec2<f32>,
    @align(8) home_0 : vec2<f32>,
    @align(8) frame_0 : u32,
    @align(4) _pad_0 : u32,
};

@binding(1) @group(0) var<storage, read> data_particles_0 : array<Particle_std430_0>;

struct VertexOut_0
{
    @builtin(position) position_1 : vec4<f32>,
    @location(0) uv_0 : vec2<f32>,
};

@vertex
fn vertex(@builtin(vertex_index) vi_0 : u32, @builtin(instance_index) ii_0 : u32) -> VertexOut_0
{
    var _S1 : vec2<f32> = vec2<f32>(2.0f);
    var uv_1 : vec2<f32> = vec2<f32>(f32((vi_0 >> (u32(1)))), f32(((vi_0 + u32(1)) & (u32(1))))) * _S1 - vec2<f32>(1.0f);
    var clipPosition_0 : vec2<f32> = data_particles_0[ii_0].position_0 * _S1 / data_params_0.viewSize_0;
    var output_0 : VertexOut_0;
    output_0.uv_0 = uv_1;
    output_0.position_1 = vec4<f32>(clipPosition_0 + uv_1 * data_params_0.dotSize_0, 0.0f, 1.0f);
    return output_0;
}

struct pixelOutput_0
{
    @location(0) output_1 : f32,
};

struct pixelInput_0
{
    @location(0) uv_2 : vec2<f32>,
};

@fragment
fn fragment( _S2 : pixelInput_0) -> pixelOutput_0
{
    var _S3 : vec2<f32> = _S2.uv_2;
    var _S4 : pixelOutput_0 = pixelOutput_0( exp(- dot(_S3, _S3) * 4.0f) );
    return _S4;
}

